import config from '../../../config/config';

export const KPI_MONTHLY_CHARGEBACK_COUNT_LOAD = 'RESELLER_KPI/KPI_MONTHLY_CHARGEBACK_COUNT_LOAD';
export const KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS = 'RESELLER_KPI/KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS';
export const KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE = 'RESELLER_KPI/KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE';

export const KPI_TRANSACTION_SUMMARY_LOAD = 'RESELLER_KPI/KPI_TRANSACTION_SUMMARY_LOAD';
export const KPI_TRANSACTION_SUMMARY_SUCCESS = 'RESELLER_KPI/KPI_TRANSACTION_SUMMARY_SUCCESS';
export const KPI_TRANSACTION_SUMMARY_FAILURE = 'RESELLER_KPI/KPI_TRANSACTION_SUMMARY_FAILURE';

export function getKpiMonthlyChargebackCount(currencyId) {
    return {
        failureActionTypeOrCreator: getKpiMonthlyChargebackCountFailureActionCreator,
        fetchParams: {
            url: `${config.chargebackApiUrl}/reseller/getMonthlyChargebackCount?currencyId=${currencyId}`
        },
        loadActionTypeOrCreator: KPI_MONTHLY_CHARGEBACK_COUNT_LOAD,
        successActionTypeOrCreator: getKpiMonthlyChargebackCountSuccessActionCreator
    };
}

export function getKpiMonthlyChargebackCountSuccessActionCreator(monthlyChargebackCount) {
    return {
        monthlyChargebackCount,
        type: KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS
    };
}

export function getKpiMonthlyChargebackCountFailureActionCreator(error) {
    return {
        error,
        type: KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE
    };
}

export function getKpiTransactionSummary(currencyId) {
    return {
        failureActionTypeOrCreator: getKpiTransactionSummaryFailureActionCreator,
        fetchParams: {
            url: `${config.transactionsApiUrl}/reseller/getMerchantTransactionSummary?currencyId=${currencyId}`
        },
        loadActionTypeOrCreator: KPI_TRANSACTION_SUMMARY_LOAD,
        successActionTypeOrCreator: getKpiTransactionSummarySuccessActionCreator
    };
}

export function getKpiTransactionSummarySuccessActionCreator(summary) {
    return {
        summary,
        type: KPI_TRANSACTION_SUMMARY_SUCCESS
    };
}

export function getKpiTransactionSummaryFailureActionCreator(error) {
    return {
        error,
        type: KPI_TRANSACTION_SUMMARY_FAILURE
    };
}
